// Custom Pixel Tracking for Shopify Customer Login
// No webhooks required - pure frontend solution

(function() {
    'use strict';
    
    // Configuration
    const CONFIG = {
      // Your analytics service endpoint
      pixelEndpoint: 'https://your-analytics-service.com/track',
      
      // Amplitude configuration
      amplitude: {
        enabled: true,
        apiKey: '375f3e63f61b0dddd3b40830464a1e0c', 
        userId: null, 
        deviceId: null 
      },
      
      // Pixel timeout (ms) - reduced for faster response
      timeout: 2000,
      
      // Retry attempts
      maxRetries: 2,
      
      // Debug mode
      debug: true,
      
      // Loading spinner settings
      showLoadingSpinner: true,
      spinnerDuration: 1500 // Show spinner for 1.5 seconds
    };
    
    // Loading Spinner Utility Class
    class LoadingSpinner {
      constructor() {
        this.spinners = new Map();
      }
      
      // Create loading spinner
      createSpinner(button, text = 'Processing...') {
        const originalText = button.textContent;
        const originalHTML = button.innerHTML;
        
        // Create spinner element
        const spinner = document.createElement('span');
        spinner.className = 'loading-overlay__spinner';
        spinner.innerHTML = `
          <svg class="spinner" width="20" height="20" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </svg>
          <span style="margin-left: 8px;">${text}</span>
        `;
        
        // Store original content
        this.spinners.set(button, { originalText, originalHTML });
        
        // Apply loading state
        button.disabled = true;
        button.innerHTML = spinner.outerHTML;
        
        return spinner;
      }
      
      // Remove loading spinner
      removeSpinner(button) {
        const originalContent = this.spinners.get(button);
        if (originalContent) {
          button.disabled = false;
          button.innerHTML = originalContent.originalHTML;
          this.spinners.delete(button);
        }
      }
      
      // Auto-remove spinner after delay
      autoRemoveSpinner(button, delay = CONFIG.spinnerDuration) {
        setTimeout(() => {
          this.removeSpinner(button);
        }, delay);
      }
    }
    
    // Custom Pixel Class
    class CustomPixelTracker {
      constructor() {
        this.events = [];
        this.retryCount = 0;
        this.loadingSpinner = new LoadingSpinner();
        this.init();
      }
      
      // Initialize tracking
      init() {
        console.log('Custom Pixel Tracker initialized');
        
        // Inject loading spinner styles
        this.injectSpinnerStyles();
        
        // Check if we're on account page (customer logged in)
        if (this.isCustomerLoggedIn()) {
          this.trackCustomerLogin();
        }
        
        // Listen for login form submissions
        this.trackLoginForm();
        
        // Listen for registration form submissions
        this.trackRegistrationForm();
        
        // Track checkout registration
        this.trackCheckoutRegistration();
        
        // Track page transitions
        this.trackPageTransitions();
        
                // Track form interactions (CAPTCHA-friendly)
          this.trackFormInteractions();
          
          // NEW: Check for immediate transitions (when script loads on redirect page)
          this.checkImmediateTransitions();
        }
        
        // Check for immediate transitions when script loads
        checkImmediateTransitions() {
          // Check if we just came from registration/login
          const registrationAttempt = sessionStorage.getItem('custom_pixel_registration_attempt');
          const loginAttempt = sessionStorage.getItem('custom_pixel_login_attempt');
          
          if (registrationAttempt === 'true') {
            console.log('Script loaded on page after registration, checking transition...');
            // The trackPageTransitions method will handle this
          }
          
          if (loginAttempt === 'true') {
            console.log('Script loaded on page after login, checking transition...');
            // The trackPageTransitions method will handle this
          }
        }
        
        // Inject loading spinner CSS styles
      injectSpinnerStyles() {
        if (!document.getElementById('custom-pixel-spinner-styles')) {
          const style = document.createElement('style');
          style.id = 'custom-pixel-spinner-styles';
          style.textContent = `
            .loading-overlay__spinner {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              color: inherit;
              font-size: inherit;
            }
            
            .loading-overlay__spinner .spinner {
              animation: spin 2s linear infinite;
            }
            
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
            
            .loading-overlay__spinner button:disabled {
              opacity: 0.7;
              cursor: not-allowed;
            }
          `;
          document.head.appendChild(style);
        }
      }
      
            // Check if customer is logged in
        isCustomerLoggedIn() {
          // Multiple ways to detect logged-in customer
          const indicators = [
            // Shopify Liquid variables (if available)
            typeof Shopify !== 'undefined' && Shopify.customer,
            
            // Account page URL
            window.location.pathname.includes('/account') && 
            !window.location.pathname.includes('/account/login'),
            
            // Customer data in meta tags
            document.querySelector('meta[name="customer-id"]'),
            document.querySelector('[data-customer-id]'),
            
            // Customer forms/inputs
            document.querySelector('input[name="customer_id"]'),
            document.querySelector('[name="customer_id"]'),
            
            // Account navigation elements
            document.querySelector('.customer-logged-in'),
            document.querySelector('[data-customer-logged-in]')
          ];
          
          return indicators.some(Boolean);
        }
        
        // Check if user just completed registration
        isUserJustRegistered() {
          const registrationAttempt = sessionStorage.getItem('custom_pixel_registration_attempt');
          const registrationTimestamp = sessionStorage.getItem('custom_pixel_registration_timestamp');
          
          if (registrationAttempt === 'true' && registrationTimestamp) {
            const timeDiff = Date.now() - parseInt(registrationTimestamp);
            // Consider it "just registered" if within last 30 seconds
            return timeDiff < 30000;
          }
          
          return false;
        }
      
            // Track customer login event
        trackCustomerLogin() {
          // Check if user just completed registration
          if (this.isUserJustRegistered()) {
            console.log('User just completed registration, firing registration success pixel');
            
            const customerData = this.getCustomerData();
            
            this.firePixel({
              event: 'customer_registration_success',
              customer_id: customerData.id,
              customer_email: customerData.email,
              registration_method: 'form_submission',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
            
            // Clear registration flags after firing the event
            sessionStorage.removeItem('custom_pixel_registration_attempt');
            sessionStorage.removeItem('custom_pixel_registration_timestamp');
            
          } else {
            console.log('Customer logged in detected, firing login success pixel');
            
            const customerData = this.getCustomerData();
            
            this.firePixel({
              event: 'customer_login_success',
              customer_id: customerData.id,
              customer_email: customerData.email,
              login_method: 'form_submission',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          }
        }
      
      // Get customer data from page
      getCustomerData() {
        // Try multiple sources for customer data
        const customerId = 
          document.querySelector('meta[name="customer-id"]')?.content ||
          document.querySelector('[data-customer-id]')?.dataset.customerId ||
          document.querySelector('input[name="customer_id"]')?.value ||
          document.querySelector('[name="customer_id"]')?.value ||
          (window.customerData && window.customerData.id) ||
          'unknown';
        
        const customerEmail = 
          document.querySelector('meta[name="customer-email"]')?.content ||
          document.querySelector('[data-customer-email]')?.dataset.customerEmail ||
          document.querySelector('input[name="customer[email]"]')?.value ||
          (window.customerData && window.customerData.email) ||
          'unknown';
        
        return { id: customerId, email: customerEmail };
      }
      
      // Track login form submissions
      trackLoginForm() {
        const loginForm = this.findLoginForm();
        
        if (loginForm) {
          console.log('Login form found, adding tracking');
          
          // Method 1: Track on form submit (without preventing default)
          loginForm.addEventListener('submit', (e) => {
            console.log('Login form submitted - tracking attempt');
            
            const formData = this.getFormData(loginForm);
            
            // Find submit button and show loading spinner
            const submitButton = loginForm.querySelector('button[type="submit"], input[type="submit"]');
            if (submitButton && CONFIG.showLoadingSpinner) {
              this.loadingSpinner.createSpinner(submitButton, 'Signing In...');
            }
            
            // Fire pixel immediately (form will submit normally)
            this.firePixel({
              event: 'customer_login_attempt',
              customer_email: formData.email,
              customer_type: 'existing',
              has_password: formData.password.length > 0,
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
            
            // Don't prevent default - let form submit normally with CAPTCHA
            console.log('Form submission proceeding normally...');
            
            // Auto-remove spinner after delay (form will redirect anyway)
            if (submitButton && CONFIG.showLoadingSpinner) {
              this.loadingSpinner.autoRemoveSpinner(submitButton, 2000);
            }
          });
          
          // Method 2: Track on input change (backup method)
          const emailInput = loginForm.querySelector('input[type="email"], input[name="customer[email]"]');
          if (emailInput) {
            emailInput.addEventListener('blur', () => {
              if (emailInput.value) {
                console.log('Email entered - tracking input');
                this.firePixel({
                  event: 'customer_login_email_entered',
                  customer_email: emailInput.value,
                  customer_type: 'existing',
                  page_url: window.location.href,
                  timestamp: new Date().toISOString()
                });
              }
            });
          }
        }
      }
      
      // Track registration form submissions
      trackRegistrationForm() {
        const registrationForm = this.findRegistrationForm();
        
        if (registrationForm) {
          console.log('Registration form found, adding tracking');
          
          // Track on form submit
          registrationForm.addEventListener('submit', (e) => {
            console.log('Registration form submitted - tracking attempt');
            
            const formData = this.getFormData(registrationForm);
            
            // Find submit button and show loading spinner
            const submitButton = registrationForm.querySelector('button[type="submit"], input[type="submit"]');
            if (submitButton && CONFIG.showLoadingSpinner) {
              this.loadingSpinner.createSpinner(submitButton, 'Creating Account...');
            }
            
            // Fire pixel immediately (form will submit normally)
            this.firePixel({
              event: 'customer_registration_attempt',
              customer_email: formData.email,
              customer_type: 'new',
              has_password: formData.password.length > 0,
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
            
            // Don't prevent default - let form submit normally
            console.log('Registration form submission proceeding normally...');
            
            // Auto-remove spinner after delay (form will redirect anyway)
            if (submitButton && CONFIG.showLoadingSpinner) {
              this.loadingSpinner.autoRemoveSpinner(submitButton, 2000);
            }
          });
          
          // Track on input change
          const emailInput = registrationForm.querySelector('input[type="email"], input[name="customer[email]"]');
          if (emailInput) {
            emailInput.addEventListener('blur', () => {
              if (emailInput.value) {
                console.log('Registration email entered - tracking input');
                this.firePixel({
                  event: 'customer_registration_email_entered',
                  customer_email: emailInput.value,
                  customer_type: 'new',
                  page_url: window.location.href,
                  timestamp: new Date().toISOString()
                });
              }
            });
          }
        }
      }
      
      // Find login form
      findLoginForm() {
        const selectors = [
          'form[action*="/account/login"]',
          'form[action*="login"]',
          '#customer_login',
          '.customer-login form',
          'form[action*="account"]'
        ];
        
        for (let selector of selectors) {
          const form = document.querySelector(selector);
          if (form) {
            console.log('Found login form with selector:', selector);
            return form;
          }
        }
        
        return null;
      }
      
      // Find registration form
      findRegistrationForm() {
        const selectors = [
          'form[action*="/account/register"]',
          'form[action*="register"]',
          '#customer_register',
          '.customer-register form',
          'form[action*="register"]'
        ];
        
        for (let selector of selectors) {
          const form = document.querySelector(selector);
          if (form) {
            console.log('Found registration form with selector:', selector);
            return form;
          }
        }
        
        return null;
      }
      
      // Get form data
      getFormData(form) {
        const email = 
          form.querySelector('input[name="customer[email]"]')?.value ||
          form.querySelector('input[type="email"]')?.value ||
          form.querySelector('#customer_email')?.value ||
          '';
        
        const password = 
          form.querySelector('input[name="customer[password]"]')?.value ||
          form.querySelector('input[type="password"]')?.value ||
          form.querySelector('#customer_password')?.value ||
          '';
        
        return { email, password };
      }
      
            // Track page transitions
        trackPageTransitions() {
          // Store login attempt flag
          if (window.location.pathname.includes('/account/login')) {
            sessionStorage.setItem('custom_pixel_login_attempt', 'true');
            sessionStorage.setItem('custom_pixel_login_timestamp', Date.now().toString());
          }
          
          // Store registration attempt flag
          if (window.location.pathname.includes('/account/register')) {
            sessionStorage.setItem('custom_pixel_registration_attempt', 'true');
            sessionStorage.setItem('custom_pixel_registration_timestamp', Date.now().toString());
          }
          
          // Check if we came from login page to account page
          if (window.location.pathname.includes('/account') && 
              !window.location.pathname.includes('/account/login') &&
              !window.location.pathname.includes('/account/register') &&
              sessionStorage.getItem('custom_pixel_login_attempt') === 'true') {
            
            console.log('Detected login transition, firing pixel');
            sessionStorage.removeItem('custom_pixel_login_attempt');
            sessionStorage.removeItem('custom_pixel_login_timestamp');
            
            this.firePixel({
              event: 'customer_login_transition',
              from_page: '/account/login',
              to_page: window.location.pathname,
              customer_type: 'existing',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          }
          
          // Check if we came from registration page to account page
          if (window.location.pathname.includes('/account') && 
              !window.location.pathname.includes('/account/login') &&
              !window.location.pathname.includes('/account/register') &&
              sessionStorage.getItem('custom_pixel_registration_attempt') === 'true') {
            
            console.log('Detected registration transition, firing pixel');
            sessionStorage.removeItem('custom_pixel_registration_attempt');
            sessionStorage.removeItem('custom_pixel_registration_timestamp');
            
            this.firePixel({
              event: 'customer_registration_transition',
              from_page: '/account/register',
              to_page: window.location.pathname,
              customer_type: 'new',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          }
          
                   // NEW: Check if we came from registration to main page (homepage)
           if (window.location.pathname === '/' || 
               window.location.pathname === '/home' ||
               window.location.pathname === '/index') {
             
             const registrationAttempt = sessionStorage.getItem('custom_pixel_registration_attempt');
             const registrationTimestamp = sessionStorage.getItem('custom_pixel_registration_timestamp');
             
             if (registrationAttempt === 'true' && registrationTimestamp) {
               const timeDiff = Date.now() - parseInt(registrationTimestamp);
               
               // Only track if registration happened within last 10 seconds
               if (timeDiff < 10000) {
                 console.log('Detected registration transition to main page, firing pixel');
                 sessionStorage.removeItem('custom_pixel_registration_attempt');
                 sessionStorage.removeItem('custom_pixel_registration_timestamp');
                 
                 this.firePixel({
                   event: 'customer_registration_success', // Changed from transition to success
                   from_page: '/account/register',
                   to_page: window.location.pathname,
                   customer_type: 'new',
                   transition_type: 'to_main_page',
                   time_since_registration: timeDiff,
                   page_url: window.location.href,
                   timestamp: new Date().toISOString()
                 });
               }
             }
           }
          
          // NEW: Check if we came from login to main page
          if (window.location.pathname === '/' || 
              window.location.pathname === '/home' ||
              window.location.pathname === '/index') {
            
            const loginAttempt = sessionStorage.getItem('custom_pixel_login_attempt');
            const loginTimestamp = sessionStorage.getItem('custom_pixel_login_timestamp');
            
            if (loginAttempt === 'true' && loginTimestamp) {
              const timeDiff = Date.now() - parseInt(loginTimestamp);
              
              // Only track if login happened within last 10 seconds
              if (timeDiff < 10000) {
                console.log('Detected login transition to main page, firing pixel');
                sessionStorage.removeItem('custom_pixel_login_attempt');
                sessionStorage.removeItem('custom_pixel_login_timestamp');
                
                this.firePixel({
                  event: 'customer_login_transition',
                  from_page: '/account/login',
                  to_page: window.location.pathname,
                  customer_type: 'existing',
                  transition_type: 'to_main_page',
                  time_since_login: timeDiff,
                  page_url: window.location.href,
                  timestamp: new Date().toISOString()
                });
              }
            }
          }
        }
      
      // Track form interactions (CAPTCHA-friendly)
      trackFormInteractions() {
        const loginForm = this.findLoginForm();
        const registrationForm = this.findRegistrationForm();
        
        // Track login form interactions
        if (loginForm) {
          this.trackFormInteractionsHelper(loginForm, 'login');
        }
        
        // Track registration form interactions
        if (registrationForm) {
          this.trackFormInteractionsHelper(registrationForm, 'registration');
        }
      }
      
      // Helper function for form interactions
      trackFormInteractionsHelper(form, formType) {
        console.log(`Adding CAPTCHA-friendly ${formType} form tracking`);
        
        // Track when user starts typing in email field
        const emailInput = form.querySelector('input[type="email"], input[name="customer[email]"]');
        if (emailInput) {
          let emailTypingTimer;
          
          emailInput.addEventListener('input', () => {
            clearTimeout(emailTypingTimer);
            emailTypingTimer = setTimeout(() => {
              if (emailInput.value.length > 3) {
                console.log(`${formType} email typing detected`);
                this.firePixel({
                  event: `customer_${formType}_email_typing`,
                  customer_email: emailInput.value,
                  form_type: formType,
                  page_url: window.location.href,
                  timestamp: new Date().toISOString()
                });
              }
            }, 500); // Wait 500ms after user stops typing
          });
        }
        
        // Track when user focuses on password field
        const passwordInput = form.querySelector('input[type="password"], input[name="customer[password]"]');
        if (passwordInput) {
          passwordInput.addEventListener('focus', () => {
            console.log(`${formType} password field focused`);
            this.firePixel({
              event: `customer_${formType}_password_focus`,
              form_type: formType,
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          });
        }
        
        // Track form validation attempts
        form.addEventListener('invalid', (e) => {
          console.log(`${formType} form validation failed`);
          this.firePixel({
            event: `customer_${formType}_validation_error`,
            form_type: formType,
            field_name: e.target.name || 'unknown',
            page_url: window.location.href,
            timestamp: new Date().toISOString()
          });
        }, true);
      }
      
      // Track checkout registration
      trackCheckoutRegistration() {
        // Check if we're on checkout page
        if (window.location.pathname.includes('/checkout') || 
            window.location.pathname.includes('/cart') ||
            document.querySelector('[data-checkout-form]') ||
            document.querySelector('form[action*="checkout"]')) {
          
          console.log('Checkout page detected, adding registration tracking');
          
          // Track guest checkout email entry
          this.trackGuestCheckoutEmail();
          
          // Track account creation during checkout
          this.trackCheckoutAccountCreation();
          
          // Track checkout completion
          this.trackCheckoutCompletion();
        }
      }
      
      // Track guest checkout email entry
      trackGuestCheckoutEmail() {
        const emailInputs = document.querySelectorAll('input[type="email"], input[name="email"], input[name="customer[email]"]');
        
        emailInputs.forEach(emailInput => {
          emailInput.addEventListener('blur', () => {
            if (emailInput.value) {
              console.log('Guest checkout email entered');
              this.firePixel({
                event: 'guest_checkout_email_entered',
                customer_email: emailInput.value,
                customer_type: 'guest',
                page_url: window.location.href,
                timestamp: new Date().toISOString()
              });
            }
          });
        });
      }
      
      // Track account creation during checkout
      trackCheckoutAccountCreation() {
        // Look for account creation checkboxes or forms
        const accountCreationCheckbox = document.querySelector('input[name="customer[accepts_marketing]"], input[name="accepts_marketing"]');
        const accountCreationForm = document.querySelector('form[action*="checkout"]');
        
        if (accountCreationCheckbox) {
          accountCreationCheckbox.addEventListener('change', () => {
            console.log('Account creation preference changed');
            this.firePixel({
              event: 'checkout_account_creation_preference',
              accepts_marketing: accountCreationCheckbox.checked,
              customer_type: 'guest',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          });
        }
        
        if (accountCreationForm) {
          accountCreationForm.addEventListener('submit', () => {
            console.log('Checkout form submitted - potential account creation');
            this.firePixel({
              event: 'checkout_form_submitted',
              customer_type: 'guest',
              page_url: window.location.href,
              timestamp: new Date().toISOString()
            });
          });
        }
      }
      
      // Track checkout completion
      trackCheckoutCompletion() {
        // Listen for checkout success indicators
        const checkoutSuccess = () => {
          console.log('Checkout completion detected');
          this.firePixel({
            event: 'checkout_completed',
            customer_type: 'guest',
            page_url: window.location.href,
            timestamp: new Date().toISOString()
          });
        };
        
        // Multiple ways to detect checkout completion
        if (window.location.pathname.includes('/checkout/thank_you') ||
            window.location.pathname.includes('/checkout/thank-you') ||
            document.querySelector('.checkout-success') ||
            document.querySelector('[data-checkout-success]')) {
          checkoutSuccess();
        }
        
        // Listen for URL changes (SPA checkout)
        let currentUrl = window.location.href;
        const urlObserver = new MutationObserver(() => {
          if (window.location.href !== currentUrl) {
            currentUrl = window.location.href;
            if (currentUrl.includes('/checkout/thank_you') || currentUrl.includes('/checkout/thank-you')) {
              checkoutSuccess();
            }
          }
        });
        
        urlObserver.observe(document.body, { childList: true, subtree: true });
      }
      
      // Fire custom pixel
      firePixel(eventData) {
        console.log('Firing custom pixel:', eventData);
        
        // Method 1: Image pixel (most reliable) - with timeout
        this.fireImagePixel(eventData);
        
        // Method 2: JavaScript pixel (fallback) - with timeout
        this.fireJavaScriptPixel(eventData);
        
        // Method 3: Direct Amplitude tracking (if enabled)
        if (CONFIG.amplitude.enabled) {
          this.fireAmplitudePixel(eventData);
        }
        
        // Store event locally
        this.events.push(eventData);
        
        // Return promise for tracking completion
        return Promise.resolve(true);
      }
      
      // Fire image pixel (1x1 transparent GIF)
      fireImagePixel(eventData) {
        try {
          const img = new Image();
          img.style.position = 'absolute';
          img.style.left = '-9999px';
          img.style.top = '-9999px';
          img.style.width = '1px';
          img.style.height = '1px';
          
          // Build pixel URL with event data
          const pixelUrl = this.buildPixelUrl(eventData);
          img.src = pixelUrl;
          
          // Add to page
          document.body.appendChild(img);
          
          // Set timeout for pixel loading
          const pixelTimeout = setTimeout(() => {
            if (document.body.contains(img)) {
              document.body.removeChild(img);
              console.warn('Image pixel timeout, removing element');
            }
          }, CONFIG.timeout);
          
          // Clean up after load
          img.onload = () => {
            clearTimeout(pixelTimeout);
            if (document.body.contains(img)) {
              document.body.removeChild(img);
            }
            console.log('Image pixel fired successfully');
          };
          
          img.onerror = () => {
            clearTimeout(pixelTimeout);
            if (document.body.contains(img)) {
              document.body.removeChild(img);
            }
            console.warn('Image pixel failed, trying JavaScript method');
          };
          
        } catch (error) {
          console.error('Error firing image pixel:', error);
        }
      }
      
      // Fire JavaScript pixel
      fireJavaScriptPixel(eventData) {
        try {
          // Create script element
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          
          // Build tracking code
          const trackingCode = this.buildTrackingCode(eventData);
          script.textContent = trackingCode;
          
          // Add to page
          document.head.appendChild(script);
          
          // Clean up
          setTimeout(() => {
            if (document.head.contains(script)) {
              document.head.removeChild(script);
            }
          }, 1000);
          
          console.log('JavaScript pixel fired');
          
        } catch (error) {
          console.error('Error firing JavaScript pixel:', error);
        }
      }
      
      // Fire Amplitude pixel directly
      fireAmplitudePixel(eventData) {
        try {
          // Check if Amplitude is loaded
          if (typeof amplitude === 'undefined') {
            console.warn('Amplitude not loaded, skipping direct tracking');
            return;
          }
          
          // Get Amplitude instance
          const amplitudeInstance = amplitude.getInstance();
          
          // Set user ID if available
          if (eventData.customer_id && eventData.customer_id !== 'unknown') {
            amplitudeInstance.setUserId(eventData.customer_id);
          }
          
          // Set user properties
          if (eventData.customer_email && eventData.customer_email !== 'unknown') {
            amplitudeInstance.setUserProperties({
              email: eventData.customer_email,
              customer_type: eventData.customer_type || 'unknown',
              registration_method: eventData.registration_method || null,
              login_method: eventData.login_method || null
            });
          }
          
          // Prepare event properties
          const eventProperties = {
            page_url: eventData.page_url,
            timestamp: eventData.timestamp,
            customer_type: eventData.customer_type || 'unknown',
            form_type: eventData.form_type || null,
            transition_type: eventData.transition_type || null,
            from_page: eventData.from_page || null,
            to_page: eventData.to_page || null,
            time_since_registration: eventData.time_since_registration || null,
            time_since_login: eventData.time_since_login || null,
            has_password: eventData.has_password || null,
            accepts_marketing: eventData.accepts_marketing || null
          };
          
          // Remove null/undefined values
          Object.keys(eventProperties).forEach(key => {
            if (eventProperties[key] === null || eventProperties[key] === undefined) {
              delete eventProperties[key];
            }
          });
          
          // Log the event
          amplitudeInstance.logEvent(eventData.event, eventProperties);
          
          console.log('Amplitude event fired:', eventData.event, eventProperties);
          
        } catch (error) {
          console.error('Error firing Amplitude pixel:', error);
        }
      }
      
      // Build pixel URL
      buildPixelUrl(eventData) {
        const params = new URLSearchParams();
        
        // Add event data as URL parameters
        Object.keys(eventData).forEach(key => {
          params.append(key, eventData[key]);
        });
        
        // Add timestamp and random ID for cache busting
        params.append('_t', Date.now());
        params.append('_r', Math.random().toString(36).substr(2, 9));
        
        return `${CONFIG.pixelEndpoint}?${params.toString()}`;
      }
      
      // Build tracking code
      buildTrackingCode(eventData) {
        // This is where you'd put your analytics service code
        // Example for Google Analytics 4:
        return `
          if (typeof gtag !== 'undefined') {
            gtag('event', '${eventData.event}', {
              customer_id: '${eventData.customer_id || ''}',
              customer_email: '${eventData.customer_email || ''}',
              page_url: '${eventData.page_url}',
              timestamp: '${eventData.timestamp}'
            });
          }
          
          if (typeof fbq !== 'undefined') {
            fbq('track', '${eventData.event}', {
              customer_id: '${eventData.customer_id || ''}',
              customer_email: '${eventData.customer_email || ''}'
            });
          }
          
          // Amplitude tracking
          if (typeof amplitude !== 'undefined') {
            amplitude.getInstance().logEvent('${eventData.event}', {
              customer_id: '${eventData.customer_id || ''}',
              customer_email: '${eventData.customer_email || ''}',
              page_url: '${eventData.page_url}',
              timestamp: '${eventData.timestamp}',
              customer_type: '${eventData.customer_type || ''}',
              form_type: '${eventData.form_type || ''}',
              transition_type: '${eventData.transition_type || ''}'
            });
          }
          
          // Custom analytics service
          if (typeof window.trackEvent === 'function') {
            window.trackEvent('${eventData.event}', ${JSON.stringify(eventData)});
          }
        `;
      }
      
      // Get all tracked events
      getEvents() {
        return this.events;
      }
      
      // Clear events
      clearEvents() {
        this.events = [];
      }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        window.customPixelTracker = new CustomPixelTracker();
      });
    } else {
      window.customPixelTracker = new CustomPixelTracker();
    }
    
    // Make tracker globally accessible
    window.CustomPixelTracker = CustomPixelTracker;
    
  })();
  